import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { BUTTON_SIZE, BUTTON_TYPES, Modal } from '@src/quince-components/src'
import Button from '@src/quince-components/src/atoms/button/Button'

import styles from './confirmation-modal.module.scss'
interface Props {
  onSignOut: () => void
  open: boolean
  onClose: () => void
}

export default function ConfirmationModal(props: Props) {
  const { onSignOut, open, onClose } = props
  const { t } = useTranslation('common')
  return (
    <Modal
      showCloseButton
      open={open}
      onClose={onClose}
      className={styles.modal}
      modalWrapperClassName={styles.modalWrapper}
    >
      <div className={styles.modalContent}>
        <div className={styles.title}>{t('switch_account')} </div>
        <div className={styles.description}>{t('switch_account_description')}</div>
        <Button
          className={classNames(styles.signInButton)}
          type={BUTTON_TYPES.PRIMARY}
          size={BUTTON_SIZE.LARGE}
          disabled={false}
          round
          onClick={onSignOut}
          showLoader={false}
        >
          {t('sign_out_continue')}
        </Button>
        <Button
          className={classNames(styles.signInButton, styles.cancelButton)}
          type={BUTTON_TYPES.PRIMARY}
          size={BUTTON_SIZE.LARGE}
          disabled={false}
          round
          onClick={onClose}
          showLoader={false}
        >
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  )
}
